/* ==========================================================================
   Grafiekkleuren — los van de huisstijl in index.css.

   Drie soorten, elk met één regel:

     categorisch  — SERIES, in vaste volgorde, nooit doorgedraaid. Een negende
                    reeks bestaat niet; die valt onder "overig".
     sequentieel  — één blauwe ramp, licht naar donker, voor magnitude.
     divergerend  — blauw <-> rood met een grijs midden, voor polariteit.

   Tekst draagt nooit een reekskleur; die zit alleen op de markering zelf.
   ========================================================================== */

export const SERIES = [
  '#2a78d6', // blauw
  '#eb6834', // oranje
  '#1baf7a', // aqua
  '#eda100', // geel
  '#e87ba4', // magenta
  '#008300', // groen
  '#4a3aa7', // violet
  '#e34948' // rood
] as const;

export const BLUE_RAMP = [
  '#cde2fb',
  '#b7d3f6',
  '#9ec5f4',
  '#86b6ef',
  '#6da7ec',
  '#5598e7',
  '#3987e5',
  '#2a78d6',
  '#256abf',
  '#1c5cab',
  '#184f95',
  '#104281'
] as const;

export const DIV_POS = '#2a78d6';
export const DIV_MID = '#f0efec';
export const DIV_NEG = '#e34948';

/** Inkt en lijnen in grafieken; verwijst naar dezelfde tinten als de huisstijl. */
export const CHART_INK = {
  as: '#a3a096',
  raster: '#e5e3dc',
  basislijn: '#cfccc2',
  label: '#7a776e',
  tekst: '#45443e',
  vlak: '#ffffff'
} as const;

function hexNaarRgb(hex: string): [number, number, number] {
  const h = hex.replace('#', '');
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
}

export function mengKleur(hexA: string, hexB: string, t: number): string {
  const a = hexNaarRgb(hexA);
  const b = hexNaarRgb(hexB);
  const factor = Math.max(0, Math.min(1, t));
  const uit = a.map((v, i) => Math.round(v + (b[i] - v) * factor));
  return '#' + uit.map((v) => v.toString(16).padStart(2, '0')).join('');
}

/** t loopt van -1 (rood) via 0 (grijs) naar +1 (blauw). */
export function divergerendeKleur(t: number): string {
  return t >= 0 ? mengKleur(DIV_MID, DIV_POS, t) : mengKleur(DIV_MID, DIV_NEG, -t);
}

/** Stap uit de blauwe ramp voor een waarde tussen 0 en max. */
export function sequentieleKleur(waarde: number, max: number): string | null {
  if (waarde <= 0 || max <= 0) return null;
  const stap = Math.min(BLUE_RAMP.length - 1, Math.floor((waarde / max) * (BLUE_RAMP.length - 1)));
  return BLUE_RAMP[stap];
}

/** Vanaf deze stap is de vulling donker genoeg voor witte tekst erop. */
export function inktOpRamp(waarde: number, max: number): string {
  if (waarde <= 0 || max <= 0) return CHART_INK.label;
  const stap = Math.min(BLUE_RAMP.length - 1, Math.floor((waarde / max) * (BLUE_RAMP.length - 1)));
  return stap >= 7 ? '#ffffff' : CHART_INK.tekst;
}
